export default {
  state: {
    newsletter_types: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/NewsletterTypesStore.js